// extracted by mini-css-extract-plugin
export default {"favouriteButton":"FavouriteButton-module--favouriteButton--f045b","favouriteIcon":"FavouriteButton-module--favouriteIcon--24aed"};